import React, { useState } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { ErrorGlobal } from '@xingternal/content-error';
import { BodyCopy, Headline } from '@xingternal/typography';
import { IconTick } from '@xingternal/icons';

import { useTrackPage } from '@/hooks/useTrackPage';
import { MetaData } from '@/components/MetaData';

import { RecentlyClaimedCompaniesModule } from './RecentlyClaimedCompaniesModule';
import { MostVisitedCompaniesModule } from './MostVisitedCompaniesModule';
import { CompaniesIndustriesModule } from './CompaniesIndustriesModule';

import { pagesTrackingName } from '@/utils/tracking';

import styles from './LoggedOutLandingPage.css';

const TickListItem = ({ id }: { id: string }) => (
  <div className={styles.tickListItem}>
    <IconTick className={styles.tickListItemIcon} width={24} height={24} />
    <BodyCopy className={styles.tickListItemContent}>
      <FormattedMessage
        id={id}
        values={
          {
            strong: (...text: any[]) => <strong>{text}</strong>,
          } as unknown as Record<string, React.ReactNode>
        }
      />
    </BodyCopy>
  </div>
);

const LoggedOutLandingPage: React.FC = () => {
  const intl = useIntl();

  const [error, setError] = useState<boolean>(false);

  useTrackPage({ pageName: pagesTrackingName.loggedOutLanding });
  if (error) {
    return (
      <div className={styles.errorPage}>
        <ErrorGlobal />
      </div>
    );
  }
  return (
    <>
      <MetaData
        index
        title={intl.formatMessage({ id: 'CP_100_META_TITLE_HUBPAGE' })}
        description={intl.formatMessage({
          id: 'CP_LANDING_LOGGED_OUT_HEADLINE',
        })}
      />
      <header className={styles.header}>
        <Headline as="h1" size="xxlarge">
          <FormattedMessage id="CP_LANDING_LOGGED_OUT_HEADLINE" />
        </Headline>
        <BodyCopy className={styles.info}>
          <FormattedMessage id="CP_100_LOGGEDOUT_EXISTING_PROFILES_TEXT_NEW" />
        </BodyCopy>
        <div className={styles.tickListItems}>
          <TickListItem id="CP_LANDING_LOGGED_OUT_INFORMATION_AND_UPDATES" />
          <TickListItem id="CP_LANDING_LOGGED_OUT_EMPLOYEE_REVIEWS" />
          <TickListItem id="CP_LANDING_LOGGED_OUT_INTRO_CAREER_OPORTUNITIES" />
        </div>
      </header>
      <CompaniesIndustriesModule setError={setError} />
      <RecentlyClaimedCompaniesModule setError={setError} />
      <MostVisitedCompaniesModule setError={setError} />
    </>
  );
};

export { LoggedOutLandingPage };
